const TOGGLES_MAPPED_RESPONSE = [
  {
    id: '16877221523',
    key: 'clienteling_chat',
    rolloutId: '16828636433',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: false,
    isLocal: true,
  },
  {
    id: '17027573229',
    key: 'client_notes',
    rolloutId: '17049351174',
    experimentIds: [],
    variables: [
      { id: '19349041223', key: 'title', type: 'string', defaultValue: 'PRIVATE NOTES' },
      {
        id: '19377351118',
        key: 'description',
        type: 'string',
        defaultValue: "Create, edit, delete and search notes from Client's profile",
      },
    ],
    variableKeyMap: {
      title: { id: '19349041223', key: 'title', type: 'string', defaultValue: 'PRIVATE NOTES' },
      description: {
        id: '19377351118',
        key: 'description',
        type: 'string',
        defaultValue: "Create, edit, delete and search notes from Client's profile",
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'PRIVATE NOTES',
      description: "Create, edit, delete and search notes from Client's profile",
    },
    isLocal: false,
  },
  {
    id: '17458230173',
    key: 'voice_calls_outbound',
    rolloutId: '17461500830',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '17766660354',
    key: 'email_communication',
    rolloutId: '17773910355',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '17778290372',
    key: 'sms_communication',
    rolloutId: '17754920402',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '17790160123',
    key: 'phone_porting_done',
    rolloutId: '17791840273',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '17803720114',
    key: 'order_attribution',
    rolloutId: '17807090466',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '18182082679',
    key: 'email_assets_attachments',
    rolloutId: '18179433491',
    experimentIds: [],
    variables: [
      {
        id: '18564801649',
        key: 'description',
        type: 'string',
        defaultValue: 'While adding attachments you can now browse and add corporate marketing assets to your emails ',
      },
      { id: '18574051913', key: 'title', type: 'string', defaultValue: 'EMAIL MARKETING ASSETS' },
    ],
    variableKeyMap: {
      description: {
        id: '18564801649',
        key: 'description',
        type: 'string',
        defaultValue: 'While adding attachments you can now browse and add corporate marketing assets to your emails ',
      },
      title: { id: '18574051913', key: 'title', type: 'string', defaultValue: 'EMAIL MARKETING ASSETS' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: 'While adding attachments you can now browse and add corporate marketing assets to your emails ',
      title: 'EMAIL MARKETING ASSETS',
    },
    isLocal: false,
  },
  {
    id: '18708620099',
    key: 'marketing_scripts_email_sharing',
    rolloutId: '18696840424',
    experimentIds: [],
    variables: [
      {
        id: '18808910091',
        key: 'description',
        type: 'string',
        defaultValue: 'Add scripts through the "+" icon when creating an email. ',
      },
      { id: '18815111523', key: 'title', type: 'string', defaultValue: 'EMAIL MARKETING SCRIPTS' },
    ],
    variableKeyMap: {
      description: {
        id: '18808910091',
        key: 'description',
        type: 'string',
        defaultValue: 'Add scripts through the "+" icon when creating an email. ',
      },
      title: { id: '18815111523', key: 'title', type: 'string', defaultValue: 'EMAIL MARKETING SCRIPTS' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: 'Add scripts through the "+" icon when creating an email. ',
      title: 'EMAIL MARKETING SCRIPTS',
    },
    isLocal: false,
  },
  {
    id: '18820641198',
    key: 'custom_group_selection_for_email',
    rolloutId: '18811155174',
    experimentIds: [],
    variables: [
      { id: '18971551443', key: 'title', type: 'string', defaultValue: 'EMAIL A GROUP' },
      {
        id: '18986470647',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now send an email, a product recommendation, or a Look to a group!',
      },
    ],
    variableKeyMap: {
      title: { id: '18971551443', key: 'title', type: 'string', defaultValue: 'EMAIL A GROUP' },
      description: {
        id: '18986470647',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now send an email, a product recommendation, or a Look to a group!',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'EMAIL A GROUP',
      description: 'You can now send an email, a product recommendation, or a Look to a group!',
    },
    isLocal: false,
  },
  {
    id: '19181930744',
    key: 'plcc_phase2_loyalty_updates',
    rolloutId: '19187560582',
    experimentIds: [],
    variables: [
      { id: '20572140537', key: 'title', type: 'string', defaultValue: 'Enhanced Incircle Account' },
      {
        id: '20584420050',
        key: 'description',
        type: 'string',
        defaultValue: 'View Authorized User on a Incircle account',
      },
    ],
    variableKeyMap: {
      title: { id: '20572140537', key: 'title', type: 'string', defaultValue: 'Enhanced Incircle Account' },
      description: {
        id: '20584420050',
        key: 'description',
        type: 'string',
        defaultValue: 'View Authorized User on a Incircle account',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Enhanced Incircle Account',
      description: 'View Authorized User on a Incircle account',
    },
    isLocal: false,
  },
  {
    id: '19257850005',
    key: 'email_recipient_limit',
    rolloutId: '19189773403',
    experimentIds: [],
    variables: [
      {
        id: '19321662429',
        key: 'description',
        type: 'string',
        defaultValue: 'Send an email to up to 20 clients at a time',
      },
      { id: '19344701135', key: 'title', type: 'string', defaultValue: 'EMAIL RECIPIENT LIMIT' },
    ],
    variableKeyMap: {
      description: {
        id: '19321662429',
        key: 'description',
        type: 'string',
        defaultValue: 'Send an email to up to 20 clients at a time',
      },
      title: { id: '19344701135', key: 'title', type: 'string', defaultValue: 'EMAIL RECIPIENT LIMIT' },
    },
    isEnabled: false,
    localValue: {
      value: false,
      description: 'Send an email to up to 20 clients at a time',
      title: 'EMAIL RECIPIENT LIMIT',
    },
    isLocal: false,
  },
  {
    id: '19584132442',
    key: 'ice_checkout',
    rolloutId: '19609561858',
    experimentIds: [],
    variables: [
      { id: '19611223898', key: 'title', type: 'string', defaultValue: 'PRECIOUS JEWELRY CHECKOUT' },
      {
        id: '19697260904',
        key: 'description',
        type: 'string',
        defaultValue: 'Checking out Precious Jewelry is now available!',
      },
    ],
    variableKeyMap: {
      title: { id: '19611223898', key: 'title', type: 'string', defaultValue: 'PRECIOUS JEWELRY CHECKOUT' },
      description: {
        id: '19697260904',
        key: 'description',
        type: 'string',
        defaultValue: 'Checking out Precious Jewelry is now available!',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'PRECIOUS JEWELRY CHECKOUT',
      description: 'Checking out Precious Jewelry is now available!',
    },
    isLocal: false,
  },
  {
    id: '19597720987',
    key: 'sort_filter_promo_points_card',
    rolloutId: '19599091881',
    experimentIds: [],
    variables: [
      { id: '19732417244', key: 'title', type: 'string', defaultValue: 'Filter and Sort by Promo or Point Cards' },
      {
        id: '19857761922',
        key: 'description',
        type: 'string',
        defaultValue:
          'Filter clients in Client List and groups by Promo or Point card availability and sort by card balance',
      },
    ],
    variableKeyMap: {
      title: {
        id: '19732417244',
        key: 'title',
        type: 'string',
        defaultValue: 'Filter and Sort by Promo or Point Cards',
      },
      description: {
        id: '19857761922',
        key: 'description',
        type: 'string',
        defaultValue:
          'Filter clients in Client List and groups by Promo or Point card availability and sort by card balance',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Filter and Sort by Promo or Point Cards',
      description:
        'Filter clients in Client List and groups by Promo or Point card availability and sort by card balance',
    },
    isLocal: false,
  },
  {
    id: '19612733598',
    key: 'non_plcc_and_virtual_cards',
    rolloutId: '19572244823',
    experimentIds: [],
    variables: [
      { id: '19872550088', key: 'title', type: 'string', defaultValue: 'Digital Promo and Point Cards' },
      {
        id: '19880260879',
        key: 'description',
        type: 'string',
        defaultValue: "View digital Points and Promo card in Client's profile",
      },
    ],
    variableKeyMap: {
      title: { id: '19872550088', key: 'title', type: 'string', defaultValue: 'Digital Promo and Point Cards' },
      description: {
        id: '19880260879',
        key: 'description',
        type: 'string',
        defaultValue: "View digital Points and Promo card in Client's profile",
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Digital Promo and Point Cards',
      description: "View digital Points and Promo card in Client's profile",
    },
    isLocal: false,
  },
  {
    id: '19739928866',
    key: 'sample_client_list_page',
    rolloutId: '19865490511',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '19747295871',
    key: 'reminders',
    rolloutId: '19745656895',
    experimentIds: [],
    variables: [
      {
        id: '20003700087',
        key: 'description',
        type: 'string',
        defaultValue:
          ' Create reminders from the dashboard and client profile.\nView and list all reminders due today and past due from the dashboard \n',
      },
      { id: '20019220099', key: 'title', type: 'string', defaultValue: 'CREATE AND VIEW REMINDERS' },
    ],
    variableKeyMap: {
      description: {
        id: '20003700087',
        key: 'description',
        type: 'string',
        defaultValue:
          ' Create reminders from the dashboard and client profile.\nView and list all reminders due today and past due from the dashboard \n',
      },
      title: { id: '20019220099', key: 'title', type: 'string', defaultValue: 'CREATE AND VIEW REMINDERS' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description:
        ' Create reminders from the dashboard and client profile.\nView and list all reminders due today and past due from the dashboard \n',
      title: 'CREATE AND VIEW REMINDERS',
    },
    isLocal: false,
  },
  {
    id: '20000430940',
    key: 'email_prompt',
    rolloutId: '19996191066',
    experimentIds: [],
    variables: [
      { id: '20062295452', key: 'title', type: 'string', defaultValue: 'EMAIL PROMPTS' },
      {
        id: '20083242687',
        key: 'description',
        type: 'string',
        defaultValue: 'A step-by-step journey to creating personalized outreach.',
      },
    ],
    variableKeyMap: {
      title: { id: '20062295452', key: 'title', type: 'string', defaultValue: 'EMAIL PROMPTS' },
      description: {
        id: '20083242687',
        key: 'description',
        type: 'string',
        defaultValue: 'A step-by-step journey to creating personalized outreach.',
      },
    },
    isEnabled: false,
    localValue: {
      value: false,
      title: 'EMAIL PROMPTS',
      description: 'A step-by-step journey to creating personalized outreach.',
    },
    isLocal: false,
  },
  {
    id: '20002070009',
    key: 'email_signature',
    rolloutId: '19979961209',
    experimentIds: [],
    variables: [
      {
        id: '20061762912',
        key: 'description',
        type: 'string',
        defaultValue: 'Add signature to your emails in Connect ',
      },
      { id: '20080970416', key: 'title', type: 'string', defaultValue: 'EMAIL SIGNATURE' },
    ],
    variableKeyMap: {
      description: {
        id: '20061762912',
        key: 'description',
        type: 'string',
        defaultValue: 'Add signature to your emails in Connect ',
      },
      title: { id: '20080970416', key: 'title', type: 'string', defaultValue: 'EMAIL SIGNATURE' },
    },
    isEnabled: true,
    localValue: { value: true, description: 'Add signature to your emails in Connect ', title: 'EMAIL SIGNATURE' },
    isLocal: false,
  },
  {
    id: '20055473918',
    key: 'email_compose_look_attachment',
    rolloutId: '20045933598',
    experimentIds: [],
    variables: [
      { id: '20104592765', key: 'title', type: 'string', defaultValue: 'ADD A LOOK FROM EMAIL' },
      {
        id: '20111803905',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now add a LOOK while composing an email.',
      },
    ],
    variableKeyMap: {
      title: { id: '20104592765', key: 'title', type: 'string', defaultValue: 'ADD A LOOK FROM EMAIL' },
      description: {
        id: '20111803905',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now add a LOOK while composing an email.',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'ADD A LOOK FROM EMAIL',
      description: 'You can now add a LOOK while composing an email.',
    },
    isLocal: false,
  },
  {
    id: '20139855822',
    key: 'client_profile_style_preference',
    rolloutId: '20144304982',
    experimentIds: [],
    variables: [
      { id: '20334801067', key: 'title', type: 'string', defaultValue: 'CAPTURE STYLE PREFERENCES FOR YOUR CLIENTS' },
      {
        id: '20346044333',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now capture your client preferences for style, lifestyle and shopping habits!',
      },
    ],
    variableKeyMap: {
      title: {
        id: '20334801067',
        key: 'title',
        type: 'string',
        defaultValue: 'CAPTURE STYLE PREFERENCES FOR YOUR CLIENTS',
      },
      description: {
        id: '20346044333',
        key: 'description',
        type: 'string',
        defaultValue: 'You can now capture your client preferences for style, lifestyle and shopping habits!',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'CAPTURE STYLE PREFERENCES FOR YOUR CLIENTS',
      description: 'You can now capture your client preferences for style, lifestyle and shopping habits!',
    },
    isLocal: false,
  },
  {
    id: '20159790679',
    key: 'support_extended_delivery_failure_statuses',
    rolloutId: '20139859173',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20212461319',
    key: 'client_personal_information',
    rolloutId: '20231161359',
    experimentIds: [],
    variables: [
      { id: '20319912704', key: 'title', type: 'string', defaultValue: 'SAVE CLIENT PERSONAL INFORMATION' },
      {
        id: '20326820723',
        key: 'description',
        type: 'string',
        defaultValue:
          "Save additional personal information like birthday, special dates, family member, and communication preference in Client's profile!",
      },
    ],
    variableKeyMap: {
      title: { id: '20319912704', key: 'title', type: 'string', defaultValue: 'SAVE CLIENT PERSONAL INFORMATION' },
      description: {
        id: '20326820723',
        key: 'description',
        type: 'string',
        defaultValue:
          "Save additional personal information like birthday, special dates, family member, and communication preference in Client's profile!",
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'SAVE CLIENT PERSONAL INFORMATION',
      description:
        "Save additional personal information like birthday, special dates, family member, and communication preference in Client's profile!",
    },
    isLocal: false,
  },
  {
    id: '20271162339',
    key: 'sms_communication_v2',
    rolloutId: '20248581360',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20279285691',
    key: 'lifestyle_style_preference',
    rolloutId: '20287150253',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20305831861',
    key: 'shopping_habits_style_preference',
    rolloutId: '20307374433',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20307482354',
    key: 'size_and_fit_style_preference',
    rolloutId: '20303733119',
    experimentIds: [],
    variables: [
      {
        id: '20354122513',
        key: 'description',
        type: 'string',
        defaultValue: "You can now capture your client's size & fit preferences in Style tab",
      },
      {
        id: '20367240951',
        key: 'title',
        type: 'string',
        defaultValue: 'CAPTURE SIZE and FIT PREFERENCES FOR YOUR CLIENTS',
      },
    ],
    variableKeyMap: {
      description: {
        id: '20354122513',
        key: 'description',
        type: 'string',
        defaultValue: "You can now capture your client's size & fit preferences in Style tab",
      },
      title: {
        id: '20367240951',
        key: 'title',
        type: 'string',
        defaultValue: 'CAPTURE SIZE and FIT PREFERENCES FOR YOUR CLIENTS',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: "You can now capture your client's size & fit preferences in Style tab",
      title: 'CAPTURE SIZE and FIT PREFERENCES FOR YOUR CLIENTS',
    },
    isLocal: false,
  },
  {
    id: '20369858338',
    key: 'in_app_chat',
    rolloutId: '20372581587',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20377920910',
    key: 'phone_porting_voice_calls',
    rolloutId: '20386957984',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20402611476',
    key: 'expanded_associate_scorecard_redesign',
    rolloutId: '20388476570',
    experimentIds: [],
    variables: [
      {
        id: '20536468746',
        key: 'description',
        type: 'string',
        defaultValue: 'Associate scorecard now includes average trips per customer and average trip value.',
      },
      { id: '20562450597', key: 'title', type: 'string', defaultValue: 'Expanded Scorecard' },
    ],
    variableKeyMap: {
      description: {
        id: '20536468746',
        key: 'description',
        type: 'string',
        defaultValue: 'Associate scorecard now includes average trips per customer and average trip value.',
      },
      title: { id: '20562450597', key: 'title', type: 'string', defaultValue: 'Expanded Scorecard' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: 'Associate scorecard now includes average trips per customer and average trip value.',
      title: 'Expanded Scorecard',
    },
    isLocal: false,
  },
  {
    id: '20506403643',
    key: 'filter_search_conversations',
    rolloutId: '20537361897',
    experimentIds: [],
    variables: [
      { id: '20605850113', key: 'title', type: 'string', defaultValue: 'Filter Messages in Inbox' },
      {
        id: '20623390051',
        key: 'description',
        type: 'string',
        defaultValue: 'Filter messages in Inbox by Type and Status',
      },
    ],
    variableKeyMap: {
      title: { id: '20605850113', key: 'title', type: 'string', defaultValue: 'Filter Messages in Inbox' },
      description: {
        id: '20623390051',
        key: 'description',
        type: 'string',
        defaultValue: 'Filter messages in Inbox by Type and Status',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Filter Messages in Inbox',
      description: 'Filter messages in Inbox by Type and Status',
    },
    isLocal: false,
  },
  {
    id: '20542333125',
    key: 'opd_merchandise_sales_logic',
    rolloutId: '20559413729',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20559386010',
    key: 'sms_look_share',
    rolloutId: '20514635200',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20575740941',
    key: 'chat_attachments',
    rolloutId: '20566370774',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20576800030',
    key: 'client_information_from_uca',
    rolloutId: '20577581639',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20596030799',
    key: 'in_app_chat_non_mvp',
    rolloutId: '20613020742',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20679361116',
    key: 'client_look_share_chat',
    rolloutId: '20689210637',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20702731514',
    key: 'bg_uca_account_creation_flow',
    rolloutId: '20745550021',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20723331979',
    key: 'inbox_multi_profile_contact_client_name',
    rolloutId: '20734260406',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20732430219',
    key: 'online_cart_api_v2',
    rolloutId: '20739620015',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20753761668',
    key: 'viewing_product_reservations',
    rolloutId: '20769231860',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20759422345',
    key: 'takes_lp_override',
    rolloutId: '20769970630',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20765213974',
    key: 'client_profile_link_from_messages',
    rolloutId: '20743814423',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20770931469',
    key: 'product_reservations',
    rolloutId: '20769291585',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20777490633',
    key: 'attachments_page',
    rolloutId: '20768330650',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20824103228',
    key: 'preselect_date_ranges_to_performance_page',
    rolloutId: '20804782002',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20886452472',
    key: 'additional_pins_in_cart',
    rolloutId: '20930973847',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20896132647',
    key: 'event_based_looks',
    rolloutId: '20890571549',
    experimentIds: [],
    variables: [
      { id: '20960250061', key: 'title', type: 'string', defaultValue: 'Holiday Looks' },
      {
        id: '20973790096',
        key: 'description',
        type: 'string',
        defaultValue: 'A new category of Looks is available for holiday!',
      },
    ],
    variableKeyMap: {
      title: { id: '20960250061', key: 'title', type: 'string', defaultValue: 'Holiday Looks' },
      description: {
        id: '20973790096',
        key: 'description',
        type: 'string',
        defaultValue: 'A new category of Looks is available for holiday!',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Holiday Looks',
      description: 'A new category of Looks is available for holiday!',
    },
    isLocal: false,
  },
  {
    id: '20905777203',
    key: 'sales_associate_match_notification',
    rolloutId: '20894624191',
    experimentIds: [],
    variables: [
      { id: '21053150325', key: 'title', type: 'string', defaultValue: 'Digital Client Leads' },
      {
        id: '21057170114',
        key: 'description',
        type: 'string',
        defaultValue:
          'Associates will now see their Digital Client Leads in an automated client group, and will be notified when matched with new clients.',
      },
    ],
    variableKeyMap: {
      title: { id: '21053150325', key: 'title', type: 'string', defaultValue: 'Digital Client Leads' },
      description: {
        id: '21057170114',
        key: 'description',
        type: 'string',
        defaultValue:
          'Associates will now see their Digital Client Leads in an automated client group, and will be notified when matched with new clients.',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Digital Client Leads',
      description:
        'Associates will now see their Digital Client Leads in an automated client group, and will be notified when matched with new clients.',
    },
    isLocal: false,
  },
  {
    id: '20910332970',
    key: 'manager-product-reservations',
    rolloutId: '20910374128',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '20913382942',
    key: 'attribution_link_clipboard_copy',
    rolloutId: '20905633635',
    experimentIds: [],
    variables: [
      { id: '20886554490', key: 'title', type: 'string', defaultValue: 'Copy Attributed Link' },
      {
        id: '20919623752',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can copy their attributed link directly from the Product Detail Page.',
      },
    ],
    variableKeyMap: {
      title: { id: '20886554490', key: 'title', type: 'string', defaultValue: 'Copy Attributed Link' },
      description: {
        id: '20919623752',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can copy their attributed link directly from the Product Detail Page.',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Copy Attributed Link',
      description: 'Associates can copy their attributed link directly from the Product Detail Page.',
    },
    isLocal: false,
  },
  {
    id: '20915410752',
    key: 'home_page_widget_customization',
    rolloutId: '20890630903',
    experimentIds: [],
    variables: [
      { id: '21106511245', key: 'title', type: 'string', defaultValue: 'Home Page Customization' },
      {
        id: '21108921256',
        key: 'description',
        type: 'string',
        defaultValue:
          'Sales Associates can now customize the widgets displayed on their home screen by making selections in their profile.',
      },
    ],
    variableKeyMap: {
      title: { id: '21106511245', key: 'title', type: 'string', defaultValue: 'Home Page Customization' },
      description: {
        id: '21108921256',
        key: 'description',
        type: 'string',
        defaultValue:
          'Sales Associates can now customize the widgets displayed on their home screen by making selections in their profile.',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Home Page Customization',
      description:
        'Sales Associates can now customize the widgets displayed on their home screen by making selections in their profile.',
    },
    isLocal: false,
  },
  {
    id: '20925856144',
    key: 'voids_order_details_page',
    rolloutId: '20921465747',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20968890503',
    key: 'notification_pagination',
    rolloutId: '20997070229',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '20985150883',
    key: 'stanley_eligible_client_group',
    rolloutId: '20932691216',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21085611671',
    key: 'purchase_insights',
    rolloutId: '21097470261',
    experimentIds: [],
    variables: [
      { id: '21364220345', key: 'title', type: 'string', defaultValue: 'Customer Purchase Insights' },
      {
        id: '21369660223',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can now view purchase insights on customer profiles.',
      },
    ],
    variableKeyMap: {
      title: { id: '21364220345', key: 'title', type: 'string', defaultValue: 'Customer Purchase Insights' },
      description: {
        id: '21369660223',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can now view purchase insights on customer profiles.',
      },
    },
    isEnabled: false,
    localValue: {
      value: false,
      title: 'Customer Purchase Insights',
      description: 'Associates can now view purchase insights on customer profiles.',
    },
    isLocal: false,
  },
  {
    id: '21136090823',
    key: 'resort_22_look_category',
    rolloutId: '21102580786',
    experimentIds: [],
    variables: [
      { id: '21213683015', key: 'title', type: 'string', defaultValue: 'Resort 2022 ' },
      {
        id: '21241771822',
        key: 'description',
        type: 'string',
        defaultValue: 'New category of Looks is now available for Resort 2022!',
      },
    ],
    variableKeyMap: {
      title: { id: '21213683015', key: 'title', type: 'string', defaultValue: 'Resort 2022 ' },
      description: {
        id: '21241771822',
        key: 'description',
        type: 'string',
        defaultValue: 'New category of Looks is now available for Resort 2022!',
      },
    },
    isEnabled: false,
    localValue: {
      value: false,
      title: 'Resort 2022 ',
      description: 'New category of Looks is now available for Resort 2022!',
    },
    isLocal: false,
  },
  {
    id: '21152810472',
    key: 'client_search_email_default_option',
    rolloutId: '21162410768',
    experimentIds: [],
    variables: [
      { id: '21234910197', key: 'title', type: 'string', defaultValue: 'client search: email as default' },
      {
        id: '21242160269',
        key: 'description',
        type: 'string',
        defaultValue: 'Email is the default metric for global client search',
      },
    ],
    variableKeyMap: {
      title: { id: '21234910197', key: 'title', type: 'string', defaultValue: 'client search: email as default' },
      description: {
        id: '21242160269',
        key: 'description',
        type: 'string',
        defaultValue: 'Email is the default metric for global client search',
      },
    },
    isEnabled: false,
    localValue: {
      value: false,
      title: 'client search: email as default',
      description: 'Email is the default metric for global client search',
    },
    isLocal: false,
  },
  {
    id: '21152831150',
    key: 'looks_2_0',
    rolloutId: '21164541360',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21187990530',
    key: 'stylist_mgr_dashboard',
    rolloutId: '21190260593',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21213661167',
    key: 'targeted_client_list',
    rolloutId: '21204551090',
    experimentIds: [],
    variables: [
      {
        id: '22018660017',
        key: 'description',
        type: 'string',
        defaultValue: "President's and Chairman's Challenge filters are now active on Client List. Expires 10/24",
      },
      { id: '22029120502', key: 'title', type: 'string', defaultValue: "President's and Chairman's Challenge" },
    ],
    variableKeyMap: {
      description: {
        id: '22018660017',
        key: 'description',
        type: 'string',
        defaultValue: "President's and Chairman's Challenge filters are now active on Client List. Expires 10/24",
      },
      title: { id: '22029120502', key: 'title', type: 'string', defaultValue: "President's and Chairman's Challenge" },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: "President's and Chairman's Challenge filters are now active on Client List. Expires 10/24",
      title: "President's and Chairman's Challenge",
    },
    isLocal: false,
  },
  {
    id: '21222000013',
    key: 'product_share_commision_attribution',
    rolloutId: '21235320011',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21260480939',
    key: 'search_all_reservations',
    rolloutId: '21289311246',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21262680984',
    key: 'store_sends_receipts',
    rolloutId: '21279750856',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21271400273',
    key: 'gift_card_removal',
    rolloutId: '21236220852',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21272341003',
    key: 'disable_email_recipient_limit',
    rolloutId: '21274111261',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21274700963',
    key: 'auto_populate_default_email_address',
    rolloutId: '21313021059',
    experimentIds: [],
    variables: [
      { id: '21364171252', key: 'title', type: 'string', defaultValue: 'auto populate email address as default' },
      {
        id: '21385161293',
        key: 'description',
        type: 'string',
        defaultValue:
          'When composing a new email, Preferred email address (if selected) will auto-populate to To: field. ',
      },
    ],
    variableKeyMap: {
      title: {
        id: '21364171252',
        key: 'title',
        type: 'string',
        defaultValue: 'auto populate email address as default',
      },
      description: {
        id: '21385161293',
        key: 'description',
        type: 'string',
        defaultValue:
          'When composing a new email, Preferred email address (if selected) will auto-populate to To: field. ',
      },
    },
    isEnabled: false,
    localValue: {
      value: false,
      title: 'auto populate email address as default',
      description:
        'When composing a new email, Preferred email address (if selected) will auto-populate to To: field. ',
    },
    isLocal: false,
  },
  {
    id: '21278010622',
    key: 'instore_expanded_payment_options',
    rolloutId: '21295670011',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21289850235',
    key: 'client_online_bag_tab',
    rolloutId: '21304010647',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21331362584',
    key: 'store_mapping_sa_access',
    rolloutId: '21337072107',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21341321811',
    key: 'look_text_character_limit',
    rolloutId: '21343331901',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21358290066',
    key: 'online_bag_to_concierge_bag',
    rolloutId: '21383420086',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21415460316',
    key: 'international_billing_payments',
    rolloutId: '21406040517',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21475252552',
    key: 'order_details_page_and_conditions',
    rolloutId: '21464442156',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21484501577',
    key: 'instore_gift_cards',
    rolloutId: '21478641233',
    experimentIds: [],
    variables: [
      {
        id: '22636550285',
        key: 'Description',
        type: 'string',
        defaultValue: 'Gift cards can be used for MPOS transactions.',
      },
      { id: '22655560194', key: 'Title', type: 'string', defaultValue: 'Gift Card For MPOS' },
    ],
    variableKeyMap: {
      Description: {
        id: '22636550285',
        key: 'Description',
        type: 'string',
        defaultValue: 'Gift cards can be used for MPOS transactions.',
      },
      Title: { id: '22655560194', key: 'Title', type: 'string', defaultValue: 'Gift Card For MPOS' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      Description: 'Gift cards can be used for MPOS transactions.',
      Title: 'Gift Card For MPOS',
    },
    isLocal: false,
  },
  {
    id: '21500450866',
    key: 'channel_breakdown_performance_page',
    rolloutId: '21497751851',
    experimentIds: [],
    variables: [
      { id: '21646900541', key: 'title', type: 'string', defaultValue: 'Channel Breakdown for SA sales' },
      {
        id: '21679281107',
        key: 'description',
        type: 'string',
        defaultValue: 'Mgrs and SAs can see a breakdown of their sales by channel on the performance page',
      },
    ],
    variableKeyMap: {
      title: { id: '21646900541', key: 'title', type: 'string', defaultValue: 'Channel Breakdown for SA sales' },
      description: {
        id: '21679281107',
        key: 'description',
        type: 'string',
        defaultValue: 'Mgrs and SAs can see a breakdown of their sales by channel on the performance page',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Channel Breakdown for SA sales',
      description: 'Mgrs and SAs can see a breakdown of their sales by channel on the performance page',
    },
    isLocal: false,
  },
  {
    id: '21502950030',
    key: 'product_details_omni_product_db',
    rolloutId: '21472250438',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21530840064',
    key: 'nm_associate_reservations',
    rolloutId: '21528460293',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21561690805',
    key: 'new_edit_content_dca',
    rolloutId: '21545533101',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21573120179',
    key: 'new_edit_content',
    rolloutId: '21556240273',
    experimentIds: [],
    variables: [
      {
        id: '22103420506',
        key: 'description',
        type: 'string',
        defaultValue:
          'New Editorial Content (Edits) available to all Connect Users. Edits can be seen in the Style Module and shared via email/text',
      },
      { id: '22117130126', key: 'title', type: 'string', defaultValue: 'Introducing Edits' },
    ],
    variableKeyMap: {
      description: {
        id: '22103420506',
        key: 'description',
        type: 'string',
        defaultValue:
          'New Editorial Content (Edits) available to all Connect Users. Edits can be seen in the Style Module and shared via email/text',
      },
      title: { id: '22117130126', key: 'title', type: 'string', defaultValue: 'Introducing Edits' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description:
        'New Editorial Content (Edits) available to all Connect Users. Edits can be seen in the Style Module and shared via email/text',
      title: 'Introducing Edits',
    },
    isLocal: false,
  },
  {
    id: '21583370094',
    key: 'new_edit_content_digital_stylist',
    rolloutId: '21561940146',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21618002039',
    key: 'sa_percent_ly_lly',
    rolloutId: '21666950134',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21667540880',
    key: 'my-clients-relationship-group',
    rolloutId: '21677311366',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21667651157',
    key: 'my_clients_tab',
    rolloutId: '21684240599',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21679170709',
    key: 'my-clients-dcl-group',
    rolloutId: '21669381163',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21685900289',
    key: 'tracking-metrics-product-look-text-share',
    rolloutId: '21662470541',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21697290534',
    key: 'my-clients-first-trip-group',
    rolloutId: '21699380753',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21698122472',
    key: 'nmvip_group',
    rolloutId: '21711362714',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21728430012',
    key: 'edits_enhancements',
    rolloutId: '21747410032',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21732580490',
    key: 'dcl_match_date',
    rolloutId: '21694400951',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21747472228',
    key: 'client_profile_redesign',
    rolloutId: '21738401576',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21785033959',
    key: 'ecid_single_product_share',
    rolloutId: '21811591735',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21811580789',
    key: 'mgr_group_dept_clickthrough',
    rolloutId: '21813161090',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21821451104',
    key: 'ecid_look_and_edit',
    rolloutId: '21833170815',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21826620139',
    key: 'return_order',
    rolloutId: '21851620211',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21863770747',
    key: 'email-edit-share-tracking',
    rolloutId: '21868230062',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '21908241424',
    key: 'rename_chat_message',
    rolloutId: '21921921164',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21927312387',
    key: 'sales_page_group_department_filters',
    rolloutId: '21955230524',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '21962500500',
    key: 'collection_category_styleboard',
    rolloutId: '21956610455',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22016931452',
    key: 'one_app_icon_update',
    rolloutId: '22039831317',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22035156128',
    key: 'email-edit-attachment',
    rolloutId: '22081270106',
    experimentIds: [],
    variables: [
      { id: '22182730193', key: 'title', type: 'string', defaultValue: 'Add Edits from Email screen' },
      {
        id: '22205360284',
        key: 'description',
        type: 'string',
        defaultValue:
          'Users can now browse and add edits from the New Email screen by pressing the + icon then "Edits"',
      },
    ],
    variableKeyMap: {
      title: { id: '22182730193', key: 'title', type: 'string', defaultValue: 'Add Edits from Email screen' },
      description: {
        id: '22205360284',
        key: 'description',
        type: 'string',
        defaultValue:
          'Users can now browse and add edits from the New Email screen by pressing the + icon then "Edits"',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Add Edits from Email screen',
      description: 'Users can now browse and add edits from the New Email screen by pressing the + icon then "Edits"',
    },
    isLocal: false,
  },
  {
    id: '22041130127',
    key: 'product_spotlight_landing_page',
    rolloutId: '22033730096',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22057570304',
    key: 'sku-tracker-product-share-via-chat',
    rolloutId: '22015122047',
    experimentIds: [],
    variables: [
      { id: '22070262040', key: 'title', type: 'string', defaultValue: 'Sku Tracker via Chat' },
      {
        id: '22087111552',
        key: 'description',
        type: 'string',
        defaultValue: 'Users can now share Sku Trackers via Chat',
      },
    ],
    variableKeyMap: {
      title: { id: '22070262040', key: 'title', type: 'string', defaultValue: 'Sku Tracker via Chat' },
      description: {
        id: '22087111552',
        key: 'description',
        type: 'string',
        defaultValue: 'Users can now share Sku Trackers via Chat',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Sku Tracker via Chat',
      description: 'Users can now share Sku Trackers via Chat',
    },
    isLocal: false,
  },
  {
    id: '22182013054',
    key: 'gift_receipt',
    rolloutId: '22172802467',
    experimentIds: [],
    variables: [
      {
        id: '22526790933',
        key: 'Description',
        type: 'string',
        defaultValue: 'Gift Receipt can be sent to the client. ',
      },
      { id: '22567960071', key: 'Title', type: 'string', defaultValue: 'Gift Receipt' },
    ],
    variableKeyMap: {
      Description: {
        id: '22526790933',
        key: 'Description',
        type: 'string',
        defaultValue: 'Gift Receipt can be sent to the client. ',
      },
      Title: { id: '22567960071', key: 'Title', type: 'string', defaultValue: 'Gift Receipt' },
    },
    isEnabled: true,
    localValue: { value: true, Description: 'Gift Receipt can be sent to the client. ', Title: 'Gift Receipt' },
    isLocal: false,
  },
  {
    id: '22184151545',
    key: 'enable_custom_split_percentages',
    rolloutId: '22189551196',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22205241124',
    key: 'payment_sled_integration',
    rolloutId: '22172922052',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22237810176',
    key: 'expanded_product_reservations',
    rolloutId: '22253190202',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22262400260',
    key: 'pdp_sale_adornment',
    rolloutId: '22264900063',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22272230410',
    key: 'edits_holiday_category',
    rolloutId: '22298080050',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22277620233',
    key: 'email_template_header_categories',
    rolloutId: '22283230158',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22280570490',
    key: 'split_gift_receipt',
    rolloutId: '22285671087',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22285581388',
    key: 'holiday_look_category',
    rolloutId: '22297021120',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22348790174',
    key: 'dle_read_only',
    rolloutId: '22360410133',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22362641906',
    key: 'edit_bg_tab',
    rolloutId: '22369861947',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22414452440',
    key: 'order_history_item_color',
    rolloutId: '22426732608',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22427640922',
    key: 'return_date',
    rolloutId: '22380111955',
    experimentIds: [],
    variables: [
      { id: '22518470985', key: 'title', type: 'string', defaultValue: 'Return Date' },
      {
        id: '22556610121',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can see the date an item was returned',
      },
    ],
    variableKeyMap: {
      title: { id: '22518470985', key: 'title', type: 'string', defaultValue: 'Return Date' },
      description: {
        id: '22556610121',
        key: 'description',
        type: 'string',
        defaultValue: 'Associates can see the date an item was returned',
      },
    },
    isEnabled: true,
    localValue: { value: true, title: 'Return Date', description: 'Associates can see the date an item was returned' },
    isLocal: false,
  },
  {
    id: '22437732501',
    key: 'edits_styleboard_padding',
    rolloutId: '22523520057',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22456611620',
    key: 'gift_return',
    rolloutId: '22456701611',
    experimentIds: [],
    variables: [
      {
        id: '22563520111',
        key: 'description',
        type: 'string',
        defaultValue:
          "We've modified the gift return process. When a user selects Gift Return? option, the are required to enter PIM SKU / UPC and one (1) of the following fields: purchasing client name, phone/email, and/or shipping address zip code",
      },
      { id: '22577020057', key: 'title', type: 'string', defaultValue: 'Gift Returns' },
    ],
    variableKeyMap: {
      description: {
        id: '22563520111',
        key: 'description',
        type: 'string',
        defaultValue:
          "We've modified the gift return process. When a user selects Gift Return? option, the are required to enter PIM SKU / UPC and one (1) of the following fields: purchasing client name, phone/email, and/or shipping address zip code",
      },
      title: { id: '22577020057', key: 'title', type: 'string', defaultValue: 'Gift Returns' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description:
        "We've modified the gift return process. When a user selects Gift Return? option, the are required to enter PIM SKU / UPC and one (1) of the following fields: purchasing client name, phone/email, and/or shipping address zip code",
      title: 'Gift Returns',
    },
    isLocal: false,
  },
  {
    id: '22481480559',
    key: 'mobile_pos',
    rolloutId: '22422012165',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22500710060',
    key: 'nm_app_client_filter',
    rolloutId: '22532150260',
    experimentIds: [],
    variables: [
      {
        id: '22522482482',
        key: 'description',
        type: 'string',
        defaultValue: "We've added a filter to the client list for NM App users",
      },
      { id: '22554981911', key: 'title', type: 'string', defaultValue: 'NM App Filter' },
    ],
    variableKeyMap: {
      description: {
        id: '22522482482',
        key: 'description',
        type: 'string',
        defaultValue: "We've added a filter to the client list for NM App users",
      },
      title: { id: '22554981911', key: 'title', type: 'string', defaultValue: 'NM App Filter' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: "We've added a filter to the client list for NM App users",
      title: 'NM App Filter',
    },
    isLocal: false,
  },
  {
    id: '22568311939',
    key: 'my_clients_tab_all_nm_sa',
    rolloutId: '22587661774',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22582880185',
    key: 'my-clients-established-group',
    rolloutId: '22606980490',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22591740193',
    key: 'marketing_pills_cc_and_global_search',
    rolloutId: '22597500127',
    experimentIds: [],
    variables: [
      {
        id: '22612350966',
        key: 'description',
        type: 'string',
        defaultValue: 'Marketing Event Pills are now visible from Global Search and the Client Connect page.',
      },
      {
        id: '22614711412',
        key: 'title',
        type: 'string',
        defaultValue: 'Marketing Event Pills on Client Connect page and Global Search',
      },
    ],
    variableKeyMap: {
      description: {
        id: '22612350966',
        key: 'description',
        type: 'string',
        defaultValue: 'Marketing Event Pills are now visible from Global Search and the Client Connect page.',
      },
      title: {
        id: '22614711412',
        key: 'title',
        type: 'string',
        defaultValue: 'Marketing Event Pills on Client Connect page and Global Search',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: 'Marketing Event Pills are now visible from Global Search and the Client Connect page.',
      title: 'Marketing Event Pills on Client Connect page and Global Search',
    },
    isLocal: false,
  },
  {
    id: '22593100974',
    key: 'expanded_client_connects_manager_view',
    rolloutId: '22586750880',
    experimentIds: [],
    variables: [
      {
        id: '22859181881',
        key: 'description',
        type: 'string',
        defaultValue: 'Managers now have visibility into their Associates Client Connects',
      },
      { id: '22862860148', key: 'title', type: 'string', defaultValue: 'Manager Visibility of Client Connects' },
    ],
    variableKeyMap: {
      description: {
        id: '22859181881',
        key: 'description',
        type: 'string',
        defaultValue: 'Managers now have visibility into their Associates Client Connects',
      },
      title: { id: '22862860148', key: 'title', type: 'string', defaultValue: 'Manager Visibility of Client Connects' },
    },
    isEnabled: true,
    localValue: {
      value: true,
      description: 'Managers now have visibility into their Associates Client Connects',
      title: 'Manager Visibility of Client Connects',
    },
    isLocal: false,
  },
  {
    id: '22607320216',
    key: 'chat_clients_group',
    rolloutId: '22584790267',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22612701541',
    key: 'two_trips_group',
    rolloutId: '22643151907',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22613010179',
    key: 'my-clients-developing-group',
    rolloutId: '22570660114',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22614662409',
    key: 'vertex_o_series',
    rolloutId: '22643692004',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22616791721',
    key: 'add_new_address',
    rolloutId: '22644991995',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22618591420',
    key: 'refresh_bg_category',
    rolloutId: '22657970407',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22633760679',
    key: 'bg_click_through',
    rolloutId: '22620850716',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22636151985',
    key: 'bg_farfetch',
    rolloutId: '22637682158',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22653201449',
    key: 'disable_unavailable_contact_options',
    rolloutId: '22641540610',
    experimentIds: [],
    variables: [
      {
        id: '22704061634',
        key: 'title',
        type: 'string',
        defaultValue: 'Disable Email & Phone when not provided on Client Profile',
      },
      {
        id: '22747040385',
        key: 'description',
        type: 'string',
        defaultValue:
          'Send via Email & Send via SMS options will be unavailable if there is no Email Address or Phone Number provided on Client Profile',
      },
    ],
    variableKeyMap: {
      title: {
        id: '22704061634',
        key: 'title',
        type: 'string',
        defaultValue: 'Disable Email & Phone when not provided on Client Profile',
      },
      description: {
        id: '22747040385',
        key: 'description',
        type: 'string',
        defaultValue:
          'Send via Email & Send via SMS options will be unavailable if there is no Email Address or Phone Number provided on Client Profile',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Disable Email & Phone when not provided on Client Profile',
      description:
        'Send via Email & Send via SMS options will be unavailable if there is no Email Address or Phone Number provided on Client Profile',
    },
    isLocal: false,
  },
  {
    id: '22661651722',
    key: 'instore_checkout_refactor',
    rolloutId: '22626262292',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22698770749',
    key: 'sa_image_upload',
    rolloutId: '22704210787',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22725021937',
    key: 'client_profile_annual_spend',
    rolloutId: '22686592105',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22751040774',
    key: 'sku_tracker_expanded_sms',
    rolloutId: '22692501938',
    experimentIds: [],
    variables: [
      { id: '22793186375', key: 'title', type: 'string', defaultValue: 'Sku Tracker Sharing Enhancements' },
      {
        id: '22807207961',
        key: 'description',
        type: 'string',
        defaultValue:
          'Sharing a sku tracker via SMS is now on an 1:1 associate to client basis.\n\nUsers can now also share Sku Trackers via NM App Message (with eligible clients).',
      },
    ],
    variableKeyMap: {
      title: { id: '22793186375', key: 'title', type: 'string', defaultValue: 'Sku Tracker Sharing Enhancements' },
      description: {
        id: '22807207961',
        key: 'description',
        type: 'string',
        defaultValue:
          'Sharing a sku tracker via SMS is now on an 1:1 associate to client basis.\n\nUsers can now also share Sku Trackers via NM App Message (with eligible clients).',
      },
    },
    isEnabled: true,
    localValue: {
      value: true,
      title: 'Sku Tracker Sharing Enhancements',
      description:
        'Sharing a sku tracker via SMS is now on an 1:1 associate to client basis.\n\nUsers can now also share Sku Trackers via NM App Message (with eligible clients).',
    },
    isLocal: false,
  },
  {
    id: '22789733016',
    key: 'sm_group_migration',
    rolloutId: '22780252482',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22799330014',
    key: 'no_limit_look_share',
    rolloutId: '22789410018',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '22857591310',
    key: 'order_submit_failure',
    rolloutId: '22772707950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '22999940998',
    key: 'mao_mpos',
    rolloutId: '23001230707',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '23200900093',
    key: 'styles_discover',
    rolloutId: '23194170510',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '23217530262',
    key: 'native_client_profile_page',
    rolloutId: '23192900172',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '23434580257',
    key: 'mao_orders',
    rolloutId: '23356651711',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '23618320157',
    key: 'use_refactored_native_concierge_checkout',
    rolloutId: '23599900497',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24218470304',
    key: 'native_app_update',
    rolloutId: '24218800081',
    experimentIds: [],
    variables: [{ id: '24222380198', key: 'version', type: 'string', defaultValue: '2.15.0' }],
    variableKeyMap: { version: { id: '24222380198', key: 'version', type: 'string', defaultValue: '2.15.0' } },
    isEnabled: false,
    localValue: { value: false, version: '2.15.0' },
    isLocal: false,
  },
  {
    id: '24404730046',
    key: 'native_mpos_voids',
    rolloutId: '24398390170',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24486580182',
    key: 'updated_share_templates',
    rolloutId: '24488030221',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24495990790',
    key: 'discover_responsive_tagnames',
    rolloutId: '24501611106',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24581260577',
    key: 'native_toggle_page',
    rolloutId: '24613670476',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: true,
    localValue: true,
    isLocal: false,
  },
  {
    id: '24677090004',
    key: 'developer_menu_screen',
    rolloutId: '24663490102',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24735510308',
    key: 'nmo_landing_link',
    rolloutId: '24729730641',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24752900558',
    key: 'native_mpos_gift_cards',
    rolloutId: '24801150640',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24771000024',
    key: 'bg_my_clients_tab',
    rolloutId: '24727380210',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24796221987',
    key: 'edits_the_refresh',
    rolloutId: '24758771293',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24926750751',
    key: 'edit_new_collection_template',
    rolloutId: '24943380241',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24928741113',
    key: 'native_refactored_my_profile_screen',
    rolloutId: '24936391341',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '24949291539',
    key: 'card_cta',
    rolloutId: '24997690551',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25007960162',
    key: 'canva_style_story',
    rolloutId: '25011700247',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25108440177',
    key: 'use_refactored_native_login_screen',
    rolloutId: '25133270129',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25121760013',
    key: 'use_refactored_native_instore_checkout',
    rolloutId: '25084240212',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25164560436',
    key: 'use_refactored_native_shopping_bag_screen',
    rolloutId: '25138680573',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25201150176',
    key: 'native_gift_receipt',
    rolloutId: '25198240015',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25235971471',
    key: 'use_attribution_v2',
    rolloutId: '25255301194',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25255390126',
    key: 'native_split_payment',
    rolloutId: '25228770136',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25279960806',
    key: 'use_refactored_native_order_history',
    rolloutId: '25310310276',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25477500067',
    key: 'use_refactored_native_browse_style_products',
    rolloutId: '25424360511',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25551980291',
    key: 'use_bg_uca_qa2_api',
    rolloutId: '25592770133',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25570830024',
    key: 'use_refactored_native_product_details_screen',
    rolloutId: '25581390035',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25617490352',
    key: 'client_style_preference',
    rolloutId: '25618490057',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25899760728',
    key: 'use_native_refactored_client_search',
    rolloutId: '25975440034',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '25974582477',
    key: 'mao_inventory',
    rolloutId: '25992011514',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '26214650005',
    key: 'automated_email_tab',
    rolloutId: '26164440452',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '26810060551',
    key: 'visually_similar_email_shares',
    rolloutId: '26770550987',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '26873300084',
    key: 'looks_product_limits',
    rolloutId: '26708771842',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '26936020312',
    key: 'use_refactored_native_plp',
    rolloutId: '26914870283',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27008560169',
    key: 'visually_similar_style_email_shares',
    rolloutId: '27076040058',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27365820042',
    key: 'beauty_replenishment_notification',
    rolloutId: '27297260544',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27679470004',
    key: 'client_connect_item_level_recommendations',
    rolloutId: '27667970008',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27686830047',
    key: 'concierge_checkout_v2',
    rolloutId: '27711680089',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27824270187',
    key: 'stylyze_additional_childrens',
    rolloutId: '27831950277',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '27976640394',
    key: 'edits_share_via_nmapp',
    rolloutId: '28001890334',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '28184210116',
    key: 'client_search_hide_default_clients_list',
    rolloutId: '28218740013',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '28187700194',
    key: 'intra_group_search',
    rolloutId: '28239510006',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '28811600279',
    key: 'gwp_concierge_cart',
    rolloutId: '28782500256',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '28956810368',
    key: 'style_photography',
    rolloutId: '28960890366',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29048140215',
    key: 'stylist_online_bags_tab',
    rolloutId: '29039710273',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29196700233',
    key: 'generic_toggle_10',
    rolloutId: '29286980025',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29198790217',
    key: 'generic_toggle_8',
    rolloutId: '29223780314',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29200360243',
    key: 'generic_toggle_1',
    rolloutId: '29267690060',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29228710377',
    key: 'generic_toggle_5',
    rolloutId: '29231480168',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29233750014',
    key: 'pay_by_link',
    rolloutId: '29250010008',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29235170151',
    key: 'generic_toggle_3',
    rolloutId: '29232410220',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29236000216',
    key: 'client_loyalty_enrollment',
    rolloutId: '29221330208',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29252790109',
    key: 'generic_toggle_9',
    rolloutId: '29250590086',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29257490202',
    key: 'generic_toggle_7',
    rolloutId: '29222140113',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29262020050',
    key: 'generic_toggle_2',
    rolloutId: '29206550319',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29266270045',
    key: 'generic_toggle_6',
    rolloutId: '29258980245',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '29271780024',
    key: 'generic_toggle_4',
    rolloutId: '29246780077',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220133',
    key: 'FbtGtzzN5SKPW3L5Rguiid',
    rolloutId: 'rollout-220133-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220141',
    key: 'native_sms',
    rolloutId: 'rollout-220141-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220149',
    key: 'loyalty_reward_barcodes',
    rolloutId: 'rollout-220149-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220241',
    key: 'loy_gift_cards',
    rolloutId: 'rollout-220241-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220242',
    key: 'nm_connect_loyalty_new',
    rolloutId: 'rollout-220242-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220243',
    key: 'bg_connect_loyalty_new',
    rolloutId: 'rollout-220243-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '220248',
    key: 'loy_cko_points',
    rolloutId: 'rollout-220248-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '221849',
    key: 'native_datepicker',
    rolloutId: 'rollout-221849-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '221850',
    key: 'native_vvic_filter',
    rolloutId: 'rollout-221850-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '225325',
    key: 'loy_hub',
    rolloutId: 'rollout-225325-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '233710',
    key: 'auto_sms_tab',
    rolloutId: 'rollout-233710-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '243171',
    key: 'updated_my_sales_page_metrics',
    rolloutId: 'rollout-243171-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '249092',
    key: 'mpos_checkout_in_sidepanel_menu',
    rolloutId: 'rollout-249092-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '249099',
    key: 'use_refactored_styleboard_tab_screen',
    rolloutId: 'rollout-249099-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '249141',
    key: 'automatic_bugged_cart_cleanup',
    rolloutId: 'rollout-249141-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '249219',
    key: 'product_scanner_fab_icons',
    rolloutId: 'rollout-249219-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '251858',
    key: 'add_card_via_pay_by_link',
    rolloutId: 'rollout-251858-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '256015',
    key: 'reduce_plp_image_sizes',
    rolloutId: 'rollout-256015-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '256146',
    key: 'native_new_email_share',
    rolloutId: 'rollout-256146-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '261233',
    key: 'auto_sms_event',
    rolloutId: 'rollout-261233-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '266762',
    key: 'online_bag_tab_for_all_users',
    rolloutId: 'rollout-266762-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '269107',
    key: 'shopping_bags_redesign',
    rolloutId: 'rollout-269107-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '272401',
    key: 'expanded_order_history_data',
    rolloutId: 'rollout-272401-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '273701',
    key: 'use_refactored_product_scanner',
    rolloutId: 'rollout-273701-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '298990',
    key: 'batch_sms',
    rolloutId: 'rollout-298990-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '299509',
    key: 'connect_product_data_for_looks',
    rolloutId: 'rollout-299509-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '301106',
    key: 'connect_pmp_integration',
    rolloutId: 'rollout-301106-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '322788',
    key: 'my_messages_comprehensive_search',
    rolloutId: 'rollout-322788-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '324120',
    key: 'osp_loyalty_api_v2',
    rolloutId: 'rollout-324120-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '325011',
    key: 'native_new_email_share_uplift',
    rolloutId: 'rollout-325011-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '325947',
    key: 'designers_category_screen_uplift',
    rolloutId: 'rollout-325947-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '330220',
    key: 'pmp_pay_by_link',
    rolloutId: 'rollout-330220-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '330973',
    key: 'connect_product_data_for_photography',
    rolloutId: 'rollout-330973-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '337758',
    key: 'client_search_uplift',
    rolloutId: 'rollout-337758-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '345071',
    key: 'use_edit_styleboard_v2',
    rolloutId: 'rollout-345071-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '349335',
    key: 'native_email_uplift_carousel_1',
    rolloutId: 'rollout-349335-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '349336',
    key: 'native_email_uplift_carousel_2',
    rolloutId: 'rollout-349336-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '351661',
    key: 'curbside_checkout_care_of_field',
    rolloutId: 'rollout-351661-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '353076',
    key: 'client_search_uplift_wave_2',
    rolloutId: 'rollout-353076-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '353556',
    key: 'my_groups_tab_uplift',
    rolloutId: 'rollout-353556-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '356590',
    key: 'shopping_bags_performance_uplift',
    rolloutId: 'rollout-356590-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '360339',
    key: 'connect_ecom_integration',
    rolloutId: 'rollout-360339-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '361188',
    key: 'promo_point_card_concierge_checkout',
    rolloutId: 'rollout-361188-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '371229',
    key: 'consume_bvd_from_sku',
    rolloutId: 'rollout-371229-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '374969',
    key: 'sales_details_client_multiselect',
    rolloutId: 'rollout-374969-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '376485',
    key: 'superuser_store_selection',
    rolloutId: 'rollout-376485-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '377686',
    key: 'create_new_group_screen_uplift',
    rolloutId: 'rollout-377686-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '378043',
    key: 'my_clients_tab_uplift',
    rolloutId: 'rollout-378043-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '381750',
    key: 'new_email_group_selection_uplift',
    rolloutId: 'rollout-381750-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '398752',
    key: 'search_clients_uplift_client_card',
    rolloutId: 'rollout-398752-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '412387',
    key: 'client_list_uplift',
    rolloutId: 'rollout-412387-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '421902',
    key: 'group_list_uplift',
    rolloutId: 'rollout-421902-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '421921',
    key: 'relationship_group_list_uplift',
    rolloutId: 'rollout-421921-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '425719',
    key: 'loyalty_phase_two',
    rolloutId: 'rollout-425719-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '428573',
    key: 'pbl_qr_codes',
    rolloutId: 'rollout-428573-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '454104',
    key: 'purchase_insights_order_history',
    rolloutId: 'rollout-454104-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '454790',
    key: 'suppress_memos_feature',
    rolloutId: 'rollout-454790-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '460358',
    key: 'stylist_shipping_auto_promo',
    rolloutId: 'rollout-460358-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '464697',
    key: 'search_clients_recent_search_dropdown',
    rolloutId: 'rollout-464697-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '469388',
    key: 'bg_product_client_recommendations',
    rolloutId: 'rollout-469388-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '470158',
    key: 'client_search_by_cmdid',
    rolloutId: 'rollout-470158-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '473578',
    key: 'share_concierge_cart_via_text',
    rolloutId: 'rollout-473578-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '475017',
    key: 'saks_email_template_tags',
    rolloutId: 'rollout-475017-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '477500',
    key: 'enable_response_error_message',
    rolloutId: 'rollout-477500-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '478630',
    key: 'online_bag_tab_uplift',
    rolloutId: 'rollout-478630-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '480046',
    key: 'hide_client_annual_spend',
    rolloutId: 'rollout-480046-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '480135',
    key: 'bgo_styleboard_landing_page',
    rolloutId: 'rollout-480135-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '480764',
    key: 'new_giftcard_expiry_date',
    rolloutId: 'rollout-480764-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
  {
    id: '481075',
    key: 'clientlist_multiselect_limit',
    rolloutId: 'rollout-481075-17902990950',
    experimentIds: [],
    variables: [],
    variableKeyMap: {},
    isEnabled: false,
    localValue: false,
    isLocal: false,
  },
];

export default TOGGLES_MAPPED_RESPONSE;
